import React, { useState } from 'react';
import { ethers } from 'ethers';
import { PACKAGE_PRICES, TOTAL_PACKAGES } from '../../config/contracts';
import { formatUsdt } from '../../utils/format';
import ActivatePackage from '../package/ActivatePackage';

// Prominent "activate your next package" card on the Home dashboard.
// Shows the next package the user can activate (topPackageId + 1).
// NOTE: Contract auto-releases the held bucket to wallet whenever the top package advances,
// so manual activation now releases any held funds — no warning needed.
const NextPackageCard = ({ topPackageId, heldBucket, onActivated }) => {
  const [showModal, setShowModal] = useState(false);

  const nextPkg = (topPackageId || 0) + 1;
  const isMax = nextPkg > TOTAL_PACKAGES;
  const bucket = heldBucket || ethers.BigNumber.from(0);
  const bucketHasFunds = !bucket.isZero();

  if (isMax) {
    return (
      <div className="next-pkg-card next-pkg-card-max">
        <div className="next-pkg-glow"></div>
        <div className="next-pkg-header">
          <div>
            <div className="next-pkg-label">
              <span className="pulse-dot" style={{ background: 'var(--warning)', boxShadow: '0 0 12px var(--warning)' }}></span>
              MAX TIER REACHED
            </div>
            <div className="next-pkg-title">Package {TOTAL_PACKAGES} Active</div>
          </div>
          <div className="next-pkg-crown">👑</div>
        </div>
        <div className="next-pkg-desc">
          You've unlocked every tier — the highest income ceiling is now active.
        </div>
      </div>
    );
  }

  const price = PACKAGE_PRICES[nextPkg - 1];

  return (
    <>
      <div className="next-pkg-card">
        <div className="next-pkg-glow"></div>
        <div className="next-pkg-header">
          <div>
            <div className="next-pkg-label">
              <span className="pulse-dot"></span>
              READY TO UPGRADE
            </div>
            <div className="next-pkg-title">Activate Package {nextPkg}</div>
          </div>
          <div className="next-pkg-price">
            <span className="np-currency">$</span>{price}
          </div>
        </div>

        <div className="next-pkg-desc">
          Unlock higher earnings + royalty eligibility. Ceiling raises to <strong>${price * 5} USDT</strong>.
        </div>

        {bucketHasFunds && (
          <div className="next-pkg-info">
            💚 You have <strong>{formatUsdt(bucket)} USDT</strong> in your held bucket. Activating
            Package {nextPkg} will automatically release it to your wallet (after 10% deduction).
          </div>
        )}

        <button
          className="btn btn-primary btn-full btn-next-pkg"
          onClick={() => setShowModal(true)}
        >
          ⚡ Activate Now for ${price}
        </button>
      </div>

      {showModal && (
        <ActivatePackage
          packageId={nextPkg}
          onClose={() => setShowModal(false)}
          onActivated={() => {
            setShowModal(false);
            if (onActivated) onActivated();
          }}
        />
      )}
    </>
  );
};

export default NextPackageCard;
